// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7360":"973e01f2bde66c0d","8977":"2d004db47e3db3ec"}[chunkId] + ".css";
};